import { css } from 'linaria';
import { breakpoints } from '../../common/styles/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-100);
`;

export const heading = css`
  margin-bottom: var(--space-200);
`;

export const listContent = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  transition: height 0.3s;
`;

export const brandLink = css`
  display: block;
  text-decoration: none;
  color: var(--text-primary);
  &:hover {
    color: var(--brand-dark);
  }
`;

export const listContentByChar = css`
  width: 100%;
  column-count: 3;
  column-gap: 150px;
  ${breakpoints.to.desktop} {
    column-count: 2;
  }
  ${breakpoints.to.tablet} {
    column-count: 1;
  }

  .${brandLink} {
    margin-bottom: var(--space-100);
  }
`;

export const brandLinkSliced = css`
  &:nth-child(n + 6) {
    display: none;
  }
`;

export const showMore = css`
  justify-content: start;
  color: var(--brand-dark);
`;
